<template>
  <e-sidebar
    :show="visible"
    :title="isEditing ? $t('Editar Exceção Fiscal') : $t('Adicionar Exceção Fiscal')"
    :fetching="fetching"
    width="900px"
    @save="save"
    @hidden="visible = false"
  >
    <template #content>
      <FormulateForm
        ref="itemForm"
        @submit="save"
      >
        <b-alert
          show
          variant="warning"
          class="p-1 mb-2"
        >
          <ul>
            <li>
              {{ $t(`Esta configuração define uma classificação fiscal que substitui a classificação do NCM para todos os produtos associados a este cadastro.`) }}
            </li>
            <br>
            <li>
              {{ $t(`Se houver NCM informado em "Informações Gerais", ao selecionar uma "UF de origem" os valores do NCM serão carregados para que você altere somente os parâmetros que deseja configurar como exceção.`) }}
            </li>
          </ul>
        </b-alert>

        <b-tabs fill>
          <b-tab :title="$t('Identificação')">
            <b-row class="mt-1">
              <b-col md="4">
                <FormulateInput
                  id="tax-configuration-group-item-state"
                  v-model="form.state"
                  name="state"
                  type="vue-select"
                  :label="$t('UF de Origem')"
                  :placeholder="$t('Todas as UFs')"
                  :options="comboStates"
                  :instruction="$t('Deixe em branco para valer como regra geral do cadastro, em qualquer estado')"
                />
              </b-col>
              <b-col md="4">
                <FormulateInput
                  id="tax-configuration-group-item-operation-type"
                  v-model="form.operationType"
                  name="operationType"
                  type="vue-select"
                  :label="$t('Tipo de Operação')"
                  :placeholder="$t('Selecione')"
                  :options="getComboOperationTypes"
                  class="required"
                  validation="required"
                />
              </b-col>
              <b-col
                v-if="isInterstate"
                md="4"
              >
                <FormulateInput
                  id="tax-configuration-group-item-destination-state"
                  v-model="form.destinationState"
                  name="destinationState"
                  type="vue-select"
                  :label="$t('UF de Destino')"
                  :placeholder="$t('Selecione')"
                  :options="comboStates"
                  class="required"
                  validation="required"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <FormulateInput
                  id="tax-configuration-group-item-cfop-output"
                  v-model="form.cfopOutput"
                  name="cfopOutput"
                  type="vue-select"
                  :label="$t('Cfop Saída')"
                  :placeholder="$t('Selecione')"
                  :options="getComboCfopOutput"
                  class="required"
                  validation="required"
                />
              </b-col>
              <b-col md="4">
                <FormulateInput
                  id="tax-configuration-group-item-cfop-input"
                  v-model="form.cfopInput"
                  name="cfopInput"
                  type="vue-select"
                  :label="$t('Cfop Entrada')"
                  :placeholder="$t('Selecione')"
                  :options="getComboCfopInput"
                />
              </b-col>
              <b-col md="4">
                <FormulateInput
                  id="tax-configuration-group-item-benefit-code"
                  v-model="form.benefitCode"
                  name="benefitCode"
                  type="text"
                  :label="$t('Código de Benefício Fiscal')"
                />
              </b-col>
            </b-row>
          </b-tab>

          <b-tab :title="$t('ICMS')">
            <b-row class="mt-1">
              <b-col md="6">
                <FormulateInput
                  id="tax-configuration-group-item-st-icms"
                  v-model="form.stIcms"
                  name="stIcms"
                  type="vue-select"
                  :label="$t('Cst Icms')"
                  :placeholder="$t('Selecione')"
                  validation="required"
                  class="required"
                  :options="comboCstIcms"
                />
              </b-col>
              <b-col md="6">
                <FormulateInput
                  id="tax-configuration-group-item-csosn-icms"
                  v-model="form.csosnIcms"
                  name="csosnIcms"
                  type="vue-select"
                  :label="$t('Csosn Icms')"
                  :placeholder="$t('Selecione')"
                  :options="comboCsosnIcms"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <FormulateInput
                  id="tax-configuration-group-item-icms-percent"
                  v-model="form.icmsPercent"
                  name="icmsPercent"
                  type="text-percetage"
                  currency="%"
                  :precision="4"
                  :label="$t('Alíquota Icms')"
                />
              </b-col>
              <b-col md="4">
                <FormulateInput
                  id="tax-configuration-group-item-icms-base-reduction-percent"
                  v-model="form.icmsBaseReductionPercent"
                  name="icmsBaseReductionPercent"
                  type="text-percetage"
                  currency="%"
                  :precision="4"
                  :label="$t('Redução Base Icms')"
                />
              </b-col>
              <b-col md="4">
                <FormulateInput
                  id="tax-configuration-group-item-fcp-percent"
                  v-model="form.fcpPercent"
                  name="fcpPercent"
                  type="text-percetage"
                  currency="%"
                  :precision="4"
                  :label="$t('Alíquota Fundo de Combate à Pobreza')"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <FormulateInput
                  id="tax-configuration-group-item-iva"
                  v-model="form.iva"
                  name="iva"
                  type="text-percetage"
                  currency="%"
                  :precision="4"
                  :label="$t('Iva')"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  id="tax-configuration-group-item-icms-st-percent"
                  v-model="form.icmsStPercent"
                  name="icmsStPercent"
                  type="text-percetage"
                  currency="%"
                  :precision="4"
                  :label="$t('Alíquota Icms St')"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  id="tax-configuration-group-item-icms-st-base-reduction-percent"
                  v-model="form.icmsStBaseReductionPercent"
                  name="icmsStBaseReductionPercent"
                  type="text-percetage"
                  currency="%"
                  :precision="4"
                  :label="$t('Redução Base Icms St')"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  id="tax-configuration-group-item-fcp-st-percent"
                  v-model="form.fcpStPercent"
                  name="fcpStPercent"
                  type="text-percetage"
                  currency="%"
                  :precision="4"
                  :label="$t('Alíquota Fcp St')"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <FormulateInput
                  id="tax-configuration-group-item-icms-tax-relief-reason"
                  v-model="form.icmsTaxReliefReason"
                  name="icmsTaxReliefReason"
                  type="vue-select"
                  :label="$t('Motivo da Desoneração do Icms')"
                  :placeholder="$t('Selecione')"
                  :options="comboIcmsTaxReliefReason"
                />
              </b-col>
            </b-row>
          </b-tab>

          <b-tab :title="$t('PIS/COFINS e IPI')">
            <b-row class="mt-1">
              <b-col>
                <h5>PIS</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <FormulateInput
                  id="tax-configuration-group-item-st-pis-output"
                  v-model="form.stPisOutput"
                  name="stPisOutput"
                  type="vue-select"
                  :label="$t('Cst Pis Saída')"
                  :placeholder="$t('Selecione')"
                  :options="getComboCstPisCofinsOutput"
                  class="required"
                  validation="required"
                />
              </b-col>
              <b-col md="4">
                <FormulateInput
                  id="tax-configuration-group-item-st-pis-input"
                  v-model="form.stPisInput"
                  name="stPisInput"
                  type="vue-select"
                  :label="$t('Cst Pis Entrada')"
                  :placeholder="$t('Selecione')"
                  :options="getComboCstPisCofinsInput"
                  class="required"
                  validation="required"
                />
              </b-col>
              <b-col md="4">
                <FormulateInput
                  id="tax-configuration-group-item-pis-percent"
                  v-model="form.pisPercent"
                  name="pisPercent"
                  type="text-percetage"
                  currency="%"
                  :precision="4"
                  :label="$t('Alíquota Pis')"
                />
              </b-col>
            </b-row>

            <b-row class="mt-1">
              <b-col>
                <h5>COFINS</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <FormulateInput
                  id="tax-configuration-group-item-st-cofins-output"
                  v-model="form.stCofinsOutput"
                  name="stCofinsOutput"
                  type="vue-select"
                  :label="$t('Cst Cofins Saída')"
                  :placeholder="$t('Selecione')"
                  :options="getComboCstPisCofinsOutput"
                  class="required"
                  validation="required"
                />
              </b-col>
              <b-col md="4">
                <FormulateInput
                  id="tax-configuration-group-item-st-cofins-input"
                  v-model="form.stCofinsInput"
                  name="stCofinsInput"
                  type="vue-select"
                  :label="$t('Cst Cofins Entrada')"
                  :placeholder="$t('Selecione')"
                  :options="getComboCstPisCofinsInput"
                  class="required"
                  validation="required"
                />
              </b-col>
              <b-col md="4">
                <FormulateInput
                  id="tax-configuration-group-item-cofins-percent"
                  v-model="form.cofinsPercent"
                  name="cofinsPercent"
                  type="text-percetage"
                  currency="%"
                  :precision="4"
                  :label="$t('Alíquota Cofins')"
                />
              </b-col>
            </b-row>

            <b-row class="mt-1">
              <b-col>
                <h5>IPI</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <FormulateInput
                  id="tax-configuration-group-item-st-ipi-output"
                  v-model="form.stIpiOutput"
                  name="stIpiOutput"
                  type="vue-select"
                  :label="$t('Cst Ipi Saída')"
                  :placeholder="$t('Selecione')"
                  :options="getComboCstIpiOutput"
                  class="required"
                  validation="required"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  id="tax-configuration-group-item-st-ipi-input"
                  v-model="form.stIpiInput"
                  name="stIpiInput"
                  type="vue-select"
                  :label="$t('Cst Ipi Entrada')"
                  :placeholder="$t('Selecione')"
                  :options="getComboCstIpiInput"
                  class="required"
                  validation="required"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  id="tax-configuration-group-item-ipi-percent"
                  v-model="form.ipiPercent"
                  name="ipiPercent"
                  type="text-percetage"
                  currency="%"
                  :precision="4"
                  :label="$t('Alíquota Ipi')"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  id="tax-configuration-group-item-ipi-legal-framework-code"
                  v-model="form.ipiLegalFrameworkCode"
                  name="ipiLegalFrameworkCode"
                  type="text"
                  :label="$t('Código de Enquadramento Legal')"
                />
              </b-col>
            </b-row>
          </b-tab>

        </b-tabs>
      </FormulateForm>
    </template>
  </e-sidebar>
</template>

<script>
import { BRow, BCol, BTabs, BTab, BAlert } from 'bootstrap-vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { ESidebar } from '@/views/components'
import { province } from '@/mixins'

const emptyForm = () => ({
  id: 0,
  state: null,
  operationType: 'INTERNAL',
  destinationState: null,
  active: true,
  cfopOutput: null,
  cfopInput: null,
  stIcms: null,
  csosnIcms: null,
  icmsPercent: null,
  icmsBaseReductionPercent: null,
  fcpPercent: null,
  iva: null,
  icmsStPercent: null,
  icmsStBaseReductionPercent: null,
  fcpStPercent: null,
  icmsTaxReliefReason: null,
  stIpiOutput: null,
  stIpiInput: null,
  ipiPercent: null,
  ipiLegalFrameworkCode: null,
  stPisOutput: null,
  stPisInput: null,
  pisPercent: null,
  stCofinsOutput: null,
  stCofinsInput: null,
  cofinsPercent: null,
  benefitCode: null,
})

export default {
  name: 'TaxConfigurationGroupItemSidebar',
  components: {
    ESidebar, BRow, BCol, BTabs, BTab, BAlert,
  },
  mixins: [province],
  data() {
    return {
      visible: false,
      isEditing: false,
      fetching: false,
      form: emptyForm(),
    }
  },
  computed: {
    ...mapState('pages/invoice/taxConfigurationGroups/taxConfigurationGroupMaintain', [
      'taxConfigurationGroup',
    ]),
    ...mapGetters('pages/invoice/taxConfigurationGroups/taxConfigurationGroupMaintain', [
      'hasItemWithSameKey',
    ]),
    ...mapGetters('pages/invoice/taxClassifications', [
      'getCstIcms',
      'getCsosnIcms',
      'getComboOperationTypes',
      'getComboCfopOutput',
      'getComboCfopInput',
      'getComboCstIpiOutput',
      'getComboCstIpiInput',
      'getComboCstPisCofinsOutput',
      'getComboCstPisCofinsInput',
    ]),

    isInterstate() {
      return this.form.operationType === 'INTERSTATE'
    },

    comboStates() {
      return this.provinces().map(p => ({ value: p.value, label: `${p.value} - ${p.label}` }))
    },

    // Estes getters não existem no store: os combos formatados são montados aqui, como nas
    // demais telas fiscais.
    comboCstIcms() {
      return this.getCstIcms.map(c => ({ value: c.code, label: `${c.code} - ${c.description}` }))
    },
    comboCsosnIcms() {
      return this.getCsosnIcms.map(c => ({ value: c.code, label: `${c.code} - ${c.description}` }))
    },
    comboIcmsTaxReliefReason() {
      // referência: https://atendimento.tecnospeed.com.br/hc/pt-br/articles/360014970574
      const allValues = [
        { label: '1 - Táxi', value: '1' },
        { label: '3 - Produtor Agropecuário', value: '3' },
        { label: '4 - Frotista/Locadora', value: '4' },
        { label: '5 - Diplomático/Consular', value: '5' },
        { label: '6 - Utilitários e Motocicletas da Amazônia Ocidental e Áreas de Livre Comércio', value: '6' },
        { label: '7 - SUFRAMA', value: '7' },
        { label: '8 - Venda a Órgãos Públicos', value: '8' },
        { label: '9 - Outros', value: '9' },
        { label: '10 - Deficiente Condutor (Convênio ICMS 38/12)', value: '10' },
        { label: '11 - Deficiente Não Condutor (Convênio ICMS 38/12)', value: '11' },
        { label: '12 - Órgão de fomento e desenvolvimento agropecuário', value: '12' },
        { label: '16 - Olimpíadas Rio 2016', value: '16' },
        { label: '90 - Solicitado pelo Fisco', value: '90' },
      ]

      switch (this.form.stIcms) {
        case '10':
        case '20':
        case '70':
        case '90':
          return allValues.filter(c => ['3', '9', '12'].includes(c.value))
        case '30':
          return allValues.filter(c => ['6', '7', '9'].includes(c.value))
        default:
          return allValues
      }
    },
  },
  watch: {
    // O endpoint que traz os valores do NCM exige a UF, então o pré-preenchimento só é possível
    // depois que o usuário escolhe uma. Em edição nunca sobrescreve o que já está salvo.
    'form.state': function onState(value, oldValue) {
      if (!this.visible || this.isEditing || !value || value === oldValue) return
      this.prefillFromNcm()
    },

    'form.operationType': function onOperationType(value, oldValue) {
      if (!this.visible || this.isEditing || !this.form.state || value === oldValue) return
      this.prefillFromNcm()
    },
  },
  mounted() {
    this.fetchTaxClassificationCombos()
  },
  methods: {
    ...mapActions('pages/invoice/taxClassifications', ['fetchTaxClassificationCombos']),

    async show(item) {
      this.visible = true
      this.isEditing = !!item

      if (item) {
        this.form = { ...emptyForm(), ...item }
        return
      }

      this.form = emptyForm()
    },

    /**
     * A linha é uma classificação COMPLETA, então abrir em branco obrigaria o usuário a redigitar
     * tudo. Pré-preenche com o que o NCM já tem e deixa ele alterar só a exceção.
     */
    async prefillFromNcm() {
      const ncm = this.taxConfigurationGroup?.ncm
      // Cadastro sem NCM não tem de onde copiar; sem UF o endpoint de classificação não resolve.
      if (!ncm || !this.form.state) return

      this.fetching = true
      try {
        // Só a classificação: os parâmetros da reforma não fazem parte da exceção, vêm sempre do NCM.
        const { data: classificationData } = await this.$http
          .get('/api/tax/tax-classification', {
            params: {
              ncm,
              originState: this.form.state,
              operationType: this.form.operationType,
              destinationState: this.form.destinationState || '',
            },
          })
          .catch(() => ({ data: {} }))

        // Ignora as chaves da origem: a identidade da linha é do cadastro, não do NCM.
        const { ncm: _ncm, originState, active, validations, ...classificationFields } = classificationData || {}

        this.form = {
          ...this.form,
          ...classificationFields,
          id: 0,
          state: this.form.state,
          operationType: this.form.operationType,
          destinationState: this.form.destinationState,
        }
      } finally {
        this.fetching = false
      }
    },

    save() {
      this.$refs.itemForm.showErrors()
      if (this.$refs.itemForm.hasErrors) {
        this.showInvalidDataMessage()
        return
      }

      const payload = {
        ...this.form,
        state: this.form.state || null,
        destinationState: this.isInterstate ? this.form.destinationState : '',
      }

      // A grid mostra uma linha por key: sem este bloqueio a linha entraria por cima da que já
      // existe e sumiria da tela. O sidebar fica aberto para o usuário corrigir a UF.
      if (this.hasItemWithSameKey(payload)) {
        this.showWarning({
          message: this.$t('TAX_CONFIGURATION_GROUP.VALIDATION.DUPLICATED_KEY'),
        })
        return
      }

      this.$emit(this.isEditing ? 'update' : 'create', payload)
      this.visible = false
    },
  },
}
</script>

<style scoped></style>
